import { ActionTypes as UndoActionTypes } from 'redux-undo'
import { pdfFileSelector } from 'apps/studio/store/selectors/pdf'
import { activeModeSelector } from 'apps/studio/store/selectors/studioSettings'
import {
  studioSettingsActions,
  INTRO_MODE,
  PDF_MODE,
} from 'apps/studio/store/reducers/settings/studioSettings'
const { setActiveMode } = studioSettingsActions

export const undoRedoMiddleware = store => next => action => {
  const result = next(action)
  const state = store.getState()
  const hasPdf = pdfFileSelector(state)
  const activeMode = activeModeSelector(state)

  if (action.type === UndoActionTypes.UNDO && !hasPdf) {
    // Set active mode to Intro if undo clears out the PDF
    store.dispatch(setActiveMode({ activeMode: INTRO_MODE }))
  } else if (
    action.type === UndoActionTypes.REDO &&
    activeMode === INTRO_MODE &&
    hasPdf
  ) {
    // Set active mode to PDF if redo restores PDF
    store.dispatch(setActiveMode({ activeMode: PDF_MODE }))
  }

  return result
}
